import L from "leaflet";
import { onContentReady } from "@story/story_assets/utils";

const API_KEY = 'XJQL-hEXA6t3HrR0wFsJnEoSm0Bt6DAk2mFHMNOWQMM';

class Map {
	constructor(element) {
		this.element = element;
		this.map = null;
	}

	ready() {
		const centerPosition = JSON.parse(this.element.getAttribute("data-smap-center"));
		const mapZoom = this.element.getAttribute("data-smap-zoom");

		this.map = L.map(this.element, {
			scrollWheelZoom: false,
		}).setView(centerPosition, mapZoom);

		this.map.attributionControl.setPrefix(false);

		L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
			minZoom: 0,
			maxZoom: 19,
			attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
		}).addTo(this.map);

		// L.marker(centerPosition, {
		// 	icon: L.icon({
		// 		iconUrl: RAILS_ASSET_URL("map_pin.svg"),
		// 		iconSize: [48, 64],
		// 		iconAnchor: [24, 64],
		// 	})
		// }).addTo(this.map);
	}

	addMarker(latitude, longitude, options) {
		const markerOptions = {}
		if (options.icon) {
			markerOptions["icon"] = L.icon({
				iconUrl: options.icon,
				iconSize: [42, 50],
				iconAnchor: [42 / 2, 50],
				popupAnchor: [0, -50]
			})
		}

		const marker = L.marker([latitude, longitude], markerOptions).addTo(this.map);

		if (options.popup) {
			const popup = marker.bindPopup(options.popup);
			if (options.openPopup) {
				popup.openPopup();
			}
		}
	}
}

onContentReady(parent => {

	//
	// Mini map
	//
	for (let element of parent.querySelectorAll("[data-smap][data-point]")) {
		const map = new Map(element);
		map.ready();

		const point = JSON.parse(element.getAttribute("data-point"));
		const location = point.location;
		const latitude = location[0];
		const longitude = location[1];

		map.addMarker(latitude, longitude, {
			icon: point.icon,
		})
	}


	for (let element of parent.querySelectorAll("[data-smap][data-groups]")) {
		const map = new Map(element);
		map.ready();

		let locations = [];

		const groups = JSON.parse(element.getAttribute("data-groups"));
		for (const group of groups) {
			let location = group.location;
			let latitude = location[0];
			let longitude = location[1];
			let points = group.branches;
			let firstPoint = points[0];

			locations.push([latitude, longitude]);

			let html = "<strong>" + firstPoint.title + "</strong>";

			let links = "";
			for (let j = 0; j < points.length; ++j) {
				let point = points[j];
				links += "<li>";
				links += "<a href='" + point.url + "'>" + point.subtitle + "</a>";
				links += "</li>";
			}
			html += "<ul class='list-unstyled mb-0'>" + links + "</ul>";

			map.addMarker(latitude, longitude, {
				icon: firstPoint.icon,
				popup: html
			});
		}

		if (locations.length) {
			const bounds = new L.LatLngBounds(locations);
			map.map.fitBounds(bounds, {
				padding: [60, 60]
			});
		}
	}
});
